export default __webpack_public_path__ + "static/media/pvilla6-2.67b8cde7.webp";